module.exports = "/static/assets/60eb6f3ec10cb788f4e7213b3c012de3.png";